import { RepairAndInquiriesStatusEntity } from '../customEntites/RepairAndInquiries.entity'

// UI buckets aligned with Dokuweb's official status set.
// `nameAims` covers both the German display string and the English status code
// returned by SAP/Dokuweb so the filter matches either form.
//   id 1 → Dokuweb "new"
//   id 2 → Dokuweb "in_process"
//   id 3 → Dokuweb "closed"
export const REPAIR_AND_INQUIRIES_STATUSES: RepairAndInquiriesStatusEntity[] = [
  {
    id: 1,
    name: 'Open',
    nameDe: 'Offen',
    nameAims: ['Offen', 'OPEN'],
  },
  {
    id: 2,
    name: 'In progress',
    nameDe: 'In Bearbeitung',
    nameAims: [
      'E-Mail eingegangen', 'MAIL_IN',
      'In Bearbeitung', 'IN_WORK',
      'Schritt zurück', 'BACKWARD',
      'Wartend auf Extern', 'WAIT_EXTERNAL',
      'Wartend auf Folgeticket', 'WAIT_NEXT_TICKET',
      'Weitergeleitet', 'FORWARD',
      'Wieder geöffnet', 'REOPEN',
      'Wieder geöffnet durch E-Mail-Eingang', 'REOPEN_MAIL_IN',
      'Wieder geöffnet durch Verknüpfung', 'REOPEN_LINKED',
      'Wiedervorlage', 'REMINDER',
      'Abgebrochen', 'CANCELED',
      'Alle zugeordneten Tickets geschlossen', 'LINKED_FINISHED',
      'Folgeticket erledigt', 'NEXT_FINISHED',
      'Frist abgelaufen', 'REMINDER_ENDED',
    ],
  },
  {
    id: 3,
    name: 'Completed',
    nameDe: 'Fertig gestellt',
    nameAims: [
      'Geschlossen', 'CLOSED',
      'Geschlossen durch Verknüpfung', 'CLOSED_LINKED',
      'Geschlossen nach Wartend auf Extern', 'CLOSE_EXTERNAL',
    ],
  },
]
